import Vue from 'vue'
import App from './App.vue'
import router from "@/router"
import vuetify from '@/_plugins/vuetify'
import '@/scss/main.scss'
import '@/scss/quill.core.css'
import defaultLayout from "@/layouts/default-layout"
import pageLayout from "@/layouts/page-layout"

Vue.component('default-layout', defaultLayout)
Vue.component('page-layout', pageLayout)

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
